<!--
  SOF Receiving page shell.
  - Header: active host location + To Pick/History segment.
  - Mobile (small screen): queue OR detail, one at a time (card flow).
  - Desktop: master-detail — queue as the left rail, detail fills the right pane.
-->
<ion-content class="sof-page-content">
  <div class="sof-page-header">
    <div class="sof-page-location">
      <ion-icon name="navigate-outline"></ion-icon>
      <span>{{ state.locationLabel }}</span>
    </div>
    <ion-segment
      [value]="readOnly ? 'history' : 'active'"
      (ionChange)="onSegmentChange($event)"
      class="sof-segment"
    >
      <ion-segment-button value="active">
        <ion-label>To Pick</ion-label>
      </ion-segment-button>
      <ion-segment-button value="history">
        <ion-label>History</ion-label>
      </ion-segment-button>
    </ion-segment>
  </div>

  <!-- Mobile: queue OR detail -->
  <ng-container *ngIf="isSmallScreen; else desktopLayout">
    <app-sof-queue
      *ngIf="!hasOpenSof"
      [readOnly]="readOnly"
      (sofSelected)="onSofSelected($event)"
    ></app-sof-queue>

    <app-sof-detail
      *ngIf="hasOpenSof"
      [readOnly]="readOnly"
      [isDesktop]="false"
      (backToQueue)="onBackToQueue()"
    ></app-sof-detail>
  </ng-container>

  <!-- Desktop: master-detail -->
  <ng-template #desktopLayout>
    <div class="sof-master-detail">
      <div class="sof-master-rail">
        <app-sof-queue
          [readOnly]="readOnly"
          (sofSelected)="onSofSelected($event)"
        ></app-sof-queue>
      </div>
      <div class="sof-detail-pane">
        <app-sof-detail
          *ngIf="hasOpenSof; else noSofSelected"
          [readOnly]="readOnly"
          [isDesktop]="true"
          (backToQueue)="onBackToQueue()"
        ></app-sof-detail>
        <ng-template #noSofSelected>
          <div class="sof-empty-pane">
            <ion-icon name="document-text-outline"></ion-icon>
            <p>Select a SOF from the queue to see its POs and items.</p>
          </div>
        </ng-template>
      </div>
    </div>
  </ng-template>
</ion-content>
